(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const formatMoney = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const getMenuToggle = () => $('[data-menu-toggle]');
  const getMobileMenu = () => $('[data-mobile-menu]');

  const closeMenu = () => {
    const menuToggle = getMenuToggle();
    const mobileMenu = getMobileMenu();
    if (!menuToggle || !mobileMenu) return;
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.hidden = true;
    document.body.classList.remove('menu-open');
  };

  const toggleMenu = menuToggle => {
    const mobileMenu = getMobileMenu();
    if (!menuToggle || !mobileMenu) return;
    const opening = menuToggle.getAttribute('aria-expanded') !== 'true';
    menuToggle.setAttribute('aria-expanded', String(opening));
    mobileMenu.hidden = !opening;
    document.body.classList.toggle('menu-open', opening);
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const menuToggle = target.closest('[data-menu-toggle]');
    if (menuToggle) {
      event.preventDefault();
      toggleMenu(menuToggle);
      return;
    }

    if (target.closest('[data-mobile-menu] a')) {
      closeMenu();
    }
  });

  const drawer = $('[data-cart-drawer]');
  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeCart();
      const mobileMenu = getMobileMenu();
      if (mobileMenu && !mobileMenu.hidden) closeMenu();
    }
  });

  const refreshCart = async (currency = 'USD') => {
    if (!drawer) return;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price, currency);
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><span>Bag / 00</span><p>Your bag is empty.</p><a class="text-link" href="/collections/all">Explore jewelry →</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(item => {
      const image = item.image ? `<img src="${item.image}" alt="" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : '';
      return `<div class="cart-drawer__item">${image}<div><a href="${item.url}">${item.product_title}</a>${variant}<span class="cart-drawer__item-meta">Qty ${item.quantity} · ${formatMoney(item.final_line_price, currency)}</span></div></div>`;
    }).join('');
  };

  $$('[data-media-gallery]').forEach(gallery => {
    const items = $$('[data-media-index]', gallery);
    const thumbs = $$('[data-media-target]', gallery);
    const current = $('[data-media-current]', gallery);
    const activate = index => {
      items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => activate(Number(thumb.dataset.mediaTarget))));
  });

  $$('[data-product-root]').forEach(root => {
    const form = $('[data-product-form]', root);
    const variantsScript = $('[data-product-variants]', root);
    if (!form || !variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (_) { return; }
    const currency = root.dataset.currency || 'USD';
    const idInput = $('[data-variant-id]', form);
    const price = $('[data-product-price]', root);
    const addButton = $('[data-add-to-cart]', form);
    const addLabel = $('[data-add-label]', form);
    const addPrice = $('[data-add-price]', form);

    const selectedOptions = () => $$('[data-option-position]', form)
      .filter(el => el.matches('fieldset'))
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map(fieldset => {
        const checked = $('input[type="radio"]:checked', fieldset);
        return checked ? checked.value : null;
      });

    const matchVariant = choices => variants.find(variant => {
      const optionValues = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(v => v != null);
      return choices.every((choice, index) => optionValues[index] === choice);
    });

    const updateVariant = () => {
      $$('[data-option-input]', form).forEach(input => {
        if (!input.checked) return;
        const label = root.querySelector(`[data-option-value="${input.dataset.optionPosition}"]`);
        if (label) label.textContent = input.value;
      });
      const variant = matchVariant(selectedOptions());
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Combination unavailable';
        if (addPrice) addPrice.textContent = '';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, currency);
      const available = Boolean(variant.available);
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to bag' : 'Currently unavailable';
      if (addPrice) addPrice.textContent = available ? formatMoney(variant.price, currency) : '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    $$('[data-option-input]', form).forEach(input => input.addEventListener('change', updateVariant));

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      const previous = addLabel ? addLabel.textContent : '';
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this object.');
        }
        await refreshCart(currency);
        openCart();
        if (addLabel) addLabel.textContent = 'Added';
        window.setTimeout(() => {
          addButton.disabled = false;
          if (addLabel) addLabel.textContent = previous || 'Add to bag';
        }, 900);
      } catch (error) {
        addButton.disabled = false;
        if (addLabel) addLabel.textContent = error.message || 'Try again';
      }
    });
  });
})();